import React from 'react';
import { Box, CircularProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styles } from '../../../../styles/components/searchEndAdornment'

interface SearchEndAdornmentProps {
  isFetching: boolean;
  searchValue: string;
  handleClear: () => void;
  color?: string;
  size?: number;
}

const SearchEndAdornment = ({ isFetching, searchValue, handleClear }: SearchEndAdornmentProps) => {
  if (isFetching) {
    return (
      <Box sx={{ mr: 2 }}>
        <CircularProgress size={16} color='inherit' />
      </Box>
    );
  }
  if (searchValue) {
    return (
      <IconButton sx={styles.iconButton} onClick={handleClear}>
        <CloseIcon />
      </IconButton>
    );
  }
  return null;
};

export default SearchEndAdornment;
